module.exports = __webpack_public_path__ + "static/media/equipment31.814a6c44.jpg";